(function () {
  function init(section) {
    if (section.dataset.featuredCollectionInitialized === 'true') return;
    const slider = section.querySelector('[data-featured-collection-slider]');
    const controls = section.querySelector('[data-featured-collection-controls]');
    if (!slider || !controls || typeof Flickity === 'undefined') return;
    const flkty = Flickity.data(slider);
    if (!flkty) return requestAnimationFrame(() => init(section));
    section.dataset.featuredCollectionInitialized = 'true';
    const bar = section.querySelector('[data-featured-collection-progress]');
    const prev = section.querySelector('[data-featured-collection-prev]');
    const next = section.querySelector('[data-featured-collection-next]');
    const getVisibleCells = () => {
      const cellWidth = flkty.cells[0]?.size.outerWidth || slider.clientWidth;
      return Math.max(1, Math.round(slider.clientWidth / cellWidth));
    };
    const getMaxIndex = () => Math.max(0, flkty.cells.length - getVisibleCells());
    const moveByPage = (direction) => {
      const target = Math.max(0, Math.min(flkty.selectedIndex + direction * getVisibleCells(), getMaxIndex()));
      flkty.select(target, false);
    };
    const updateProgress = (scrollProgress) => {
      const visible = Math.min(getVisibleCells(), flkty.cells.length);
      const max = getMaxIndex();
      const normalizedProgress = typeof scrollProgress === 'number'
        ? Math.max(0, Math.min(1, scrollProgress))
        : max ? Math.min(flkty.selectedIndex / max, 1) : 0;

      if (bar) {
        const width = ((visible + (flkty.cells.length - visible) * normalizedProgress) / flkty.cells.length) * 100;
        bar.style.width = `${Math.min(width, 100)}%`;
      }
    };
    const updateNavigation = () => {
      const max = getMaxIndex();
      if (flkty.selectedIndex > max) {
        flkty.select(max, false, true);
        return;
      }
      prev.disabled = !max || flkty.selectedIndex <= 0;
      next.disabled = !max || flkty.selectedIndex >= max;
    };
    prev.addEventListener('click', () => moveByPage(-1));
    next.addEventListener('click', () => moveByPage(1));
    flkty.on('scroll', updateProgress);
    flkty.on('select', updateNavigation);
    flkty.on('resize', () => {
      updateProgress();
      updateNavigation();
    });
    updateProgress();
    updateNavigation();
  }
  document.querySelectorAll('.section-featured-collection').forEach((section) => setTimeout(() => init(section), 20));
})();
